// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__C3vp8"};